"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwExpr = void 0;
function throwExpr(obj) {
    throw obj;
}
exports.throwExpr = throwExpr;
//# sourceMappingURL=throwExpr.js.map